<template>
  <div class="container">
    <el-row type="flex" justify="center">
      <el-col :xs="20" :sm="18" :md="14" :lg="16">
        <el-card class="prompt-box">
          <h2>
            密码重置还需一步
          </h2><br>
          <h4>系统已经将密码重置链接发送到您的邮箱:{{email }}</h4><br>
          <h4>请立即登录邮箱，重置成功后即可使用相关服务。</h4>
          <br>
          <el-button type="primary" @click='onMailButtion'>立即登录邮箱</el-button>
          <hr>
          <h3><strong>还没收到密码重置邮件？</strong></h3>
          <ul>
            <li>尝试到垃圾邮件目录或者广告目录里找找，或者点击这里<router-link style="color: blue" to="/user/forgotpassword">重新发送</router-link>重置邮件.</li>
            <li>检查您输入的邮箱地址是否正确，重新试试忘记密码操作</li>
            <li>如果仍不能解决问题，请尝试联系我们(jvshikeji@163.com).</li>
          </ul>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'forgotpasswordEmailConfirmPrompt',
  data () {
    return {
      email: this.$route.query.email
    }
  },
  methods: {
    onMailButtion () {
      let url = this.getEmailLoginPage(this.email)
      if (url !== '') {
        window.open(url)
      } else {
        this.$message.warning('邮箱地址可能不正确，请检查')
      }
    },
    getEmailLoginPage (mail) {
      let t = mail.split('@')[1]
      if (t !== undefined) {
        t = t.toLowerCase()
      } else {
        return ''
      }
      if (t === 'vip.163.com') {
        return 'http://vip.163.com'
      } else if (t === 'gmail.com') {
        return 'http://mail.google.com'
      } else if (t === 'vip.sina.com') {
        return 'http://vip.sina.com'
      } else if (t === 'yahoo.com.cn' || t === 'yahoo.cn') {
        return 'http://mail.yahoo.com'
      } else if (t === 'hotmail.com') {
        return 'http://www.hotmail.com'
      } else {
        // 猜测值
        return 'http://mail.' + t
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.prompt-box {
  color: #3a87ad;
  background-color: #d9edf7;
  margin-top: 25px;
}
</style>
